/**
 * @file This file contains configuration for various disasters in the game.
 * @module disastersConfig
 */

/**
 * @typedef {Object} DisasterConfig
 * @property {string} type - The type of disaster (e.g., 'slowSweep', 'fastSweep').
 * @property {string} display - The emoji or character used to display the disaster.
 * @property {string} backgroundColor - The background color of the disaster cell.
 * @property {number} frequency - The approximate number of turns between occurrences.
 * @property {object} effect - The effect of the disaster.
 * @property {string} effect.type - The type of effect (e.g., 'remove', 'temporary').
 * @property {number} [effect.duration] - The duration of the effect in milliseconds (for temporary effects).
 * @property {string} [sound] - The key of the sound to play when the disaster occurs.
 */

/**
 * Configuration object for different disasters.
 * Each key represents a unique disaster.
 * @type {Object.<string, DisasterConfig>}
 */
export const disastersConfig = {
    godzilla: {
        type: 'slowSweep',
        display: ['🦖', '🐉', '🐲'],
        backgroundColor: '#2E8B57',
        frequency: 100, // Appears roughly every 100 turns
        sound: 'godzilla',
        effect: {
            type: 'remove'
        },
    },
    whirlwind: {
        type: 'fastSweep',
        display: ['🌪️', '💨'],
        backgroundColor: '#D3D3D3',
        frequency: 150, // Appears roughly every 150 turns
        duration: 4000,
        sound: 'whirlwind',
        effect: {
            type: 'temporary',
            duration: 4000,
        },
    },
    storm: {
        type: 'random',
        display: ['⛈️', '⚡️', '🌩️'],
        backgroundColor: '#00008B',
        frequency: 80,
        duration: 4000,
        sound: 'storm',
        effect: {
            type: 'remove',
            duration: 4000
        },
    },
};